module.exports= {
    "postbox-text": "여기에 댓글을 입력해주세요(최소 3문자 이상)",
    "postbox-author": "이름 (선택)",
    "postbox-email": "이메일 (선택)",
    "postbox-website": "웹사이트 (선택)",
    "postbox-preview": "미리보기",
    "postbox-edit": "수정",
    "postbox-submit": "댓글쓰기",
    "postbox-notification": "댓글이 달리면 이메일로 알립니다",

    "num-comments": "한 개의 댓글\n{{ n }} 개의 댓글",
    "no-comments": "아직 댓글이 없습니다",
    "atom-feed": "Atom 피드",

    "comment-reply": "댓글",
    "comment-edit": "수정",
    "comment-save": "저장",
    "comment-delete": "삭제",
    "comment-confirm": "확인",
    "comment-close": "닫기",
    "comment-cancel": "취소",
    "comment-deleted": "댓글이 삭제됨.",
    "comment-queued": "검토 대기 중인 댓글.",
    "comment-anonymous": "익명",
    "comment-hidden": "{{ n }} 개의 숨김 댓글",

    "date-now": "방금 전",
    "date-minute": "1 분 전\n{{ n }} 분 전",
    "date-hour": "1 시간 전\n{{ n }} 시간 전",
    "date-day": "어제\n{{ n }} 일 전",
    "date-week": "저번 주\n{{ n }} 주 전",
    "date-month": "저번 달\n{{ n }} 개월 전",
    "date-year": "작년\n{{ n }} 년 전"
};
